import React, { useCallback, useEffect } from 'react';
import { withRouter } from "../../../Helpers/withRouter";
import { EVALUATION_STATES, EVALUATION_STATES_TRACKING } from "../../../Constants/evaluation";
import UserSession from "../../../Utils/UserSession";
import { TRACKING_EVENTS } from "../../../Constants/trackingEvents";
import { trackingHelper } from "../../../Helpers/trackingHelper";
import BookAnAppointmentViewRevamp from "./BookAnAppointmentViewRevamp";
import BookAnAppointmentViewLegacy from "./BookAnAppointmentViewLegacy";
import withConfig from "./../../../ComponentDependency/withConfig";
import { compose } from 'redux';
export var BookAnAppointment = function BookAnAppointment(_ref) {
  var templateName = _ref.templateName,
    name = _ref.name,
    data = _ref.data,
    metadata = _ref.metadata,
    location = _ref.location,
    router = _ref.router,
    track = _ref.track,
    handleIconClick = _ref.handleIconClick,
    locationId = _ref.locationId,
    origin = _ref.origin,
    landingURLSearch = _ref.landingURLSearch,
    config = _ref.config,
    params = _ref.params;
  var condition_cta = data.cta.conditions;
  var _ref2 = location || {},
    pathname = _ref2.pathname,
    search = _ref2.search;
  var _ref3 = metadata || {},
    isL2Qrevamp = _ref3.isL2Qrevamp;
  useEffect(function () {
    onTrack(TRACKING_EVENTS.VALUATION_PAGE_OPEN);
  }, []);
  var onClickAboutConditions = useCallback(function () {
    if (router != null) {
      router.push("".concat(pathname).concat(search).concat(condition_cta.action));
    }
  }, [router, pathname, search, condition_cta]);
  function onTrack(en) {
    trackingHelper({
      eventName: en || TRACKING_EVENTS.VALUATION_EDIT_CAR_DETAILS,
      track: track,
      locationId: locationId,
      origin: origin,
      select_from: EVALUATION_STATES_TRACKING.VALUATION_COMPLETE,
      landingURLSearch: landingURLSearch,
      params: params,
      config: config.get()
    });
  }
  var editIconClick = useCallback(function (e) {
    e.preventDefault();
    e.stopPropagation();
    UserSession.deleteLastSelectionOption();
    if (handleIconClick) {
      handleIconClick(EVALUATION_STATES.VALUATION_DONE);
      onTrack(null);
    }
  }, [handleIconClick]);
  if (isL2Qrevamp) {
    return /*#__PURE__*/React.createElement(BookAnAppointmentViewRevamp, Object.assign({}, {
      data: data,
      metadata: metadata,
      editIconClick: editIconClick,
      track: track
    }));
  }
  return /*#__PURE__*/React.createElement(BookAnAppointmentViewLegacy, Object.assign({}, {
    templateName: templateName,
    name: name,
    data: data,
    metadata: metadata,
    location: location,
    track: track,
    locationId: locationId,
    onClickAboutConditions: onClickAboutConditions,
    onTrack: onTrack,
    editIconClick: editIconClick
  }));
};
export default compose(withRouter, withConfig)(BookAnAppointment);